/** Chuẩn hóa tên chức năng phân quyền bộ phận — khớp BackendHeader / màn phân quyền */
export function normalizeDivisionFeatureName(value) {
  return String(value || "")
    .normalize("NFC")
    .replace(/\s+/g, " ")
    .replace(/\s*\/\s*/g, " / ")
    .trim()
    .toLowerCase();
}

export const CUSTOMERS_DIVISION_FEATURE = "NGƯỜI DÙNG / Khách hàng";

/** Nhãn nút lọc trên màn Danh sách khách hàng — khớp API countUsersCustomerCode. */
export const CUSTOMER_FILTER_GROUP_NAMES = [
  "Không mã",
  "Có mã",
  "Khách hàng",
  "ZTO-KH",
  "ZTO-VN",
  "ZTO-DL",
  "ZTO-VH",
  "ZTO-MH",
];

export function customerFilterGroupToFeature(groupName) {
  return `${CUSTOMERS_DIVISION_FEATURE} / ${groupName}`;
}

export const CUSTOMER_FILTER_DIVISION_FEATURES = CUSTOMER_FILTER_GROUP_NAMES.map(
  customerFilterGroupToFeature
);
export const PARTNERS_DIVISION_FEATURE = "NGƯỜI DÙNG / Đối tác";
/** Danh sách users (/admin-users); trong bảng chức năng nằm dưới Đối tác, trên Phân quyền. */
export const ADMIN_USERS_LIST_DIVISION_FEATURE = "NGƯỜI DÙNG / Danh sách users";
export const CATEGORIES_DIVISION_FEATURE = "SẢN PHẨM / Danh mục";
export const PROVIDERS_DIVISION_FEATURE = "SẢN PHẨM / Nhà cung cấp";
/** Bình luận & đánh giá (vote) nhà cung cấp — trong JSON phòng ban chỉ dùng cờ view. */
export const PROVIDER_RATING_COMMENT_DIVISION_FEATURE = "SẢN PHẨM / Đánh giá - bình luận";

/** Nhóm Thông báo (phân quyền bộ phận) — từng mục chỉ dùng cờ view. */
export const NOTIFY_NCC_RATING_REMINDER_FEATURE = "THÔNG BÁO / Nhắc nhở đánh giá NCC";
export const NOTIFY_TRANSFER_REQUEST_INBOX_FEATURE = "THÔNG BÁO / Nhận yêu cầu chuyển đơn";
export const NOTIFY_TRANSFER_REQUEST_PROCESS_FEATURE = "THÔNG BÁO / Được phép thực hiện chuyển đơn";
/** Quyền màn /products — tách theo loại SP (JSON phòng ban). */
export const PRODUCTS_PERSONAL_DIVISION_FEATURE = "SẢN PHẨM / Sản phẩm cá nhân";
export const PRODUCTS_SHARED_DIVISION_FEATURE = "SẢN PHẨM / Sản phẩm dùng chung";
/** Xuất Excel: trong JSON chỉ dùng cờ view. */
export const PRODUCTS_EXPORT_EXCEL_DIVISION_FEATURE = "SẢN PHẨM / Xuất file excel";

/** @deprecated Chỉ để đọc dữ liệu phân quyền cũ khi chưa lưu lại. */
export const PRODUCTS_DIVISION_FEATURE_LEGACY = "SẢN PHẨM / Sản phẩm";
export const PRODUCTS_ADD_PERSONAL_LEGACY = "SẢN PHẨM / Thêm sản phẩm cá nhân";
export const PRODUCTS_ADD_SHARED_LEGACY = "SẢN PHẨM / Thêm sản phẩm dùng chung";
/** Màn Phân quyền (#/permission) — menu «Hệ thống / Phân quyền». */
export const DEPARTMENTS_DIVISION_FEATURE = "NGƯỜI DÙNG / Phân quyền";
/** @deprecated JSON phân quyền cũ; đọc/ghi tương thích trong DivisionPermissionEditor. */
export const DEPARTMENTS_DIVISION_FEATURE_LEGACY = "NGƯỜI DÙNG / Phòng ban";
export const SYSTEM_SETTINGS_DIVISION_FEATURE = "MỞ RỘNG / Cài đặt hệ thống";
export const WEBSITE_CONTACT_DIVISION_FEATURE = "WEBSITE / Liên hệ khách hàng";
export const WEBSITE_NEWS_DIVISION_FEATURE = "WEBSITE / Quản lý bài viết";
export const CHAT_DIVISION_FEATURE = "CHAT";

/** Nhóm Chăm sóc khách hàng — role Trade widget (chỉ cờ view). */
export const CSKH_DIVISION_PARENT = "CHĂM SÓC KHÁCH HÀNG";
export const CSKH_TRADE_ROLES = ["conversations", "training_ai", "multi_channel", "setup_ai_staff"];
export const CSKH_DIVISION_FEATURES = CSKH_TRADE_ROLES.map(
  (role) => `${CSKH_DIVISION_PARENT} / ${role}`
);

export function cskhFeatureToTradeRole(feature) {
  const parts = String(feature || "")
    .split(" / ")
    .map((s) => s.trim())
    .filter(Boolean);
  return parts.length ? parts[parts.length - 1] : "";
}

/**
 * Role Trade manager theo phân quyền CSKH.
 * Admin: đủ 3 role. Member: các mục có cờ view.
 * @param {import('axios').AxiosInstance} axiosInstance
 * @returns {Promise<string[]>}
 */
export async function fetchCskhTradeRoles(axiosInstance) {
  try {
    const flagsRes = await axiosInstance.get("/api/users/myFlags");
    const flags = flagsRes?.data?.data || {};
    if (flags?.isAdmin === true) {
      return [...CSKH_TRADE_ROLES];
    }
    const permRes = await axiosInstance.get("/api/users/myDivisionPermissions");
    const rows = permRes?.data?.data || [];
    const granted = new Set();
    for (const feature of CSKH_DIVISION_FEATURES) {
      const target = normalizeDivisionFeatureName(feature);
      const row = rows.find((p) => normalizeDivisionFeatureName(p?.feature) === target);
      if (row?.view) {
        granted.add(cskhFeatureToTradeRole(feature));
      }
    }
    return CSKH_TRADE_ROLES.filter((role) => granted.has(role));
  } catch {
    return [];
  }
}
export const ACCOUNTING_DIVISION_FEATURE = "KẾ TOÁN";
/** @deprecated JSON cũ — map sang các leaf Báo cáo (không gồm Dòng tiền). */
export const ACCOUNTING_REPORT_FEATURE = "KẾ TOÁN / Báo cáo";
/** @deprecated JSON cũ — map sang leaf Công nợ. */
export const ACCOUNTING_DEBT_FEATURE = "KẾ TOÁN / Công nợ";
/** @deprecated JSON cũ — map sang leaf Phiếu thu/chi. */
export const ACCOUNTING_VOUCHER_FEATURE = "KẾ TOÁN / Phiếu thu/chi";
/** @deprecated JSON cũ — map sang leaf Cấu hình. */
export const ACCOUNTING_CONFIG_FEATURE = "KẾ TOÁN / Cấu hình";
/** @deprecated JSON cũ — map sang KẾ TOÁN / Báo cáo / Dòng tiền. */
export const ACCOUNTING_CASH_FLOW_FEATURE = "KẾ TOÁN / Dòng tiền";
/** @deprecated JSON cũ — map sang leaf Sổ chi. */
export const ACCOUNTING_HR_FEATURE = "KẾ TOÁN / Lương & Tạm ứng";
/** @deprecated alias tên nhóm Sổ chi (không còn leaf riêng). */
export const ACCOUNTING_SO_CHI_FEATURE = "KẾ TOÁN / Sổ chi";

export const ACCOUNTING_REPORT_REVENUE = "KẾ TOÁN / Báo cáo / Doanh thu";
export const ACCOUNTING_REPORT_EXPENSE = "KẾ TOÁN / Báo cáo / Chi phí";
export const ACCOUNTING_REPORT_PROFIT = "KẾ TOÁN / Báo cáo / Lợi nhuận";
export const ACCOUNTING_REPORT_ASSETS = "KẾ TOÁN / Báo cáo / Tài sản";
export const ACCOUNTING_REPORT_CASHFLOW = "KẾ TOÁN / Báo cáo / Dòng tiền";
export const ACCOUNTING_DEBT_RECEIVABLE = "KẾ TOÁN / Công nợ / Phải thu";
export const ACCOUNTING_DEBT_PAYABLE = "KẾ TOÁN / Công nợ / Phải trả";
export const ACCOUNTING_VOUCHER_RECEIPT = "KẾ TOÁN / Phiếu thu/chi / Phiếu thu";
export const ACCOUNTING_VOUCHER_PAYMENT = "KẾ TOÁN / Phiếu thu/chi / Phiếu chi";
export const ACCOUNTING_SO_CHI_SALARY = "KẾ TOÁN / Sổ chi / Bảng lương";
export const ACCOUNTING_SO_CHI_ADVANCE = "KẾ TOÁN / Sổ chi / Tạm ứng";
export const ACCOUNTING_SO_CHI_PREPAID = "KẾ TOÁN / Sổ chi / Chi phí trả trước";
export const ACCOUNTING_CONFIG_BANK = "KẾ TOÁN / Cấu hình / Tài khoản ngân hàng";
export const ACCOUNTING_CONFIG_REVENUE_CAT = "KẾ TOÁN / Cấu hình / Danh mục thu";
export const ACCOUNTING_CONFIG_EXPENSE_CAT = "KẾ TOÁN / Cấu hình / Danh mục chi";
export const ACCOUNTING_CONFIG_EXPENSE_OBJECT = "KẾ TOÁN / Cấu hình / Đối tượng chi";
export const ACCOUNTING_CONFIG_REVENUE_OBJECT = "KẾ TOÁN / Cấu hình / Đối tượng thu";
export const ACCOUNTING_CONFIG_SALARY = "KẾ TOÁN / Cấu hình / Cấu hình lương";
/** Chỉ dùng để chọn TK (modal đối soát / phiếu) — không mở menu Cấu hình TKNH. */
export const ACCOUNTING_BANK_USE_FEATURE = "KẾ TOÁN / Dùng tài khoản ngân hàng";

export const ACCOUNTING_REPORT_CORE_LEAVES = [
  ACCOUNTING_REPORT_REVENUE,
  ACCOUNTING_REPORT_EXPENSE,
  ACCOUNTING_REPORT_PROFIT,
  ACCOUNTING_REPORT_ASSETS,
];
export const ACCOUNTING_REPORT_TAB_LEAVES = [
  ...ACCOUNTING_REPORT_CORE_LEAVES,
  ACCOUNTING_REPORT_CASHFLOW,
];
export const ACCOUNTING_DEBT_LEAVES = [ACCOUNTING_DEBT_RECEIVABLE, ACCOUNTING_DEBT_PAYABLE];
export const ACCOUNTING_VOUCHER_LEAVES = [ACCOUNTING_VOUCHER_RECEIPT, ACCOUNTING_VOUCHER_PAYMENT];
export const ACCOUNTING_SO_CHI_LEAVES = [
  ACCOUNTING_SO_CHI_SALARY,
  ACCOUNTING_SO_CHI_ADVANCE,
  ACCOUNTING_SO_CHI_PREPAID,
];
export const ACCOUNTING_CONFIG_LEAVES = [
  ACCOUNTING_CONFIG_BANK,
  ACCOUNTING_CONFIG_REVENUE_CAT,
  ACCOUNTING_CONFIG_EXPENSE_CAT,
  ACCOUNTING_CONFIG_EXPENSE_OBJECT,
  ACCOUNTING_CONFIG_REVENUE_OBJECT,
  ACCOUNTING_CONFIG_SALARY,
];
export const ACCOUNTING_UTILITY_LEAVES = [ACCOUNTING_BANK_USE_FEATURE];
export const ACCOUNTING_ALL_LEAVES = [
  ...ACCOUNTING_REPORT_TAB_LEAVES,
  ...ACCOUNTING_DEBT_LEAVES,
  ...ACCOUNTING_VOUCHER_LEAVES,
  ...ACCOUNTING_SO_CHI_LEAVES,
  ...ACCOUNTING_CONFIG_LEAVES,
  ...ACCOUNTING_UTILITY_LEAVES,
];

/** Alias key cũ / nhóm → các leaf được coi như cùng quyền. */
export const ACCOUNTING_LEGACY_TO_LEAVES = {
  [ACCOUNTING_DIVISION_FEATURE]: ACCOUNTING_ALL_LEAVES,
  [ACCOUNTING_REPORT_FEATURE]: ACCOUNTING_REPORT_CORE_LEAVES,
  [ACCOUNTING_CASH_FLOW_FEATURE]: [ACCOUNTING_REPORT_CASHFLOW],
  [ACCOUNTING_DEBT_FEATURE]: ACCOUNTING_DEBT_LEAVES,
  [ACCOUNTING_VOUCHER_FEATURE]: ACCOUNTING_VOUCHER_LEAVES,
  [ACCOUNTING_HR_FEATURE]: ACCOUNTING_SO_CHI_LEAVES,
  [ACCOUNTING_SO_CHI_FEATURE]: ACCOUNTING_SO_CHI_LEAVES,
  [ACCOUNTING_CONFIG_FEATURE]: ACCOUNTING_CONFIG_LEAVES,
};

/** Bất kỳ quyền view nào trong nhóm Kế toán (legacy hoặc leaf). */
export const ACCOUNTING_VIEW_FEATURES = [
  ACCOUNTING_DIVISION_FEATURE,
  ACCOUNTING_REPORT_FEATURE,
  ACCOUNTING_DEBT_FEATURE,
  ACCOUNTING_VOUCHER_FEATURE,
  ACCOUNTING_CONFIG_FEATURE,
  ACCOUNTING_CASH_FLOW_FEATURE,
  ACCOUNTING_HR_FEATURE,
  ACCOUNTING_SO_CHI_FEATURE,
  ...ACCOUNTING_ALL_LEAVES,
];

function accountingRowAction(row, action) {
  if (!row) return false;
  if (action === "view") return Boolean(row.view);
  if (action === "create") return Boolean(row.create);
  if (action === "edit") return Boolean(row.edit);
  if (action === "delete") return Boolean(row.delete);
  return false;
}

/**
 * Resolves whether permission rows grant an action on a feature (leaf or legacy group).
 * @param {{ feature?: string, view?: boolean, create?: boolean, edit?: boolean, delete?: boolean }[]} rows
 * @param {string} featureKey
 * @param {"view"|"create"|"edit"|"delete"} action
 */
export function hasAccountingPermissionInRows(rows, featureKey, action = "view") {
  const list = Array.isArray(rows) ? rows : [];
  const target = normalizeDivisionFeatureName(featureKey);
  if (!target) return false;

  const findRow = (name) =>
    list.find((p) => normalizeDivisionFeatureName(p?.feature) === normalizeDivisionFeatureName(name));

  const legacyMaster = findRow(ACCOUNTING_DIVISION_FEATURE);
  if (accountingRowAction(legacyMaster, action)) return true;

  const exact = findRow(featureKey);
  if (accountingRowAction(exact, action)) return true;

  // Leaf requested: also accept legacy parent that maps to this leaf
  for (const [legacyKey, leaves] of Object.entries(ACCOUNTING_LEGACY_TO_LEAVES)) {
    if (legacyKey === ACCOUNTING_DIVISION_FEATURE) continue;
    const covers = leaves.some((l) => normalizeDivisionFeatureName(l) === target);
    if (!covers) continue;
    if (accountingRowAction(findRow(legacyKey), action)) return true;
  }

  // Group/legacy requested: accept if any mapped leaf has the action
  const mappedLeaves = ACCOUNTING_LEGACY_TO_LEAVES[featureKey]
    || Object.entries(ACCOUNTING_LEGACY_TO_LEAVES).find(
      ([k]) => normalizeDivisionFeatureName(k) === target
    )?.[1];
  if (mappedLeaves?.length) {
    return mappedLeaves.some((leaf) => accountingRowAction(findRow(leaf), action));
  }

  // Prefix: any leaf under "KẾ TOÁN / Báo cáo" when checking that prefix group
  if (ACCOUNTING_ALL_LEAVES.some((l) => normalizeDivisionFeatureName(l) === target)) {
    return false;
  }
  return list.some((p) => {
    const n = normalizeDivisionFeatureName(p?.feature);
    return n.startsWith(`${target} / `) && accountingRowAction(p, action);
  });
}

export function canViewAnyAccountingInRows(rows) {
  return ACCOUNTING_VIEW_FEATURES.some((f) => hasAccountingPermissionInRows(rows, f, "view"))
    || (rows || []).some((p) => {
      const n = normalizeDivisionFeatureName(p?.feature);
      return n.startsWith("kế toán") && Boolean(p?.view);
    });
}

/** Có đủ toàn bộ quyền xem tab Báo cáo (Doanh thu / Chi phí / LN / Tài sản / Dòng tiền). */
export function canViewAccountingReportsInRows(rows) {
  return ACCOUNTING_REPORT_TAB_LEAVES.every((f) => hasAccountingPermissionInRows(rows, f, "view"));
}
export const PRICE_LEVEL_DIVISION_FEATURE = "MỞ RỘNG / Bảng giá";
export const ORDER_DIVISION_FEATURE = "ĐƠN HÀNG";
/** Quản lý đơn hàng — đơn line thường (không VAT). */
export const ORDERS_NORMAL_DIVISION_FEATURE = "ĐƠN HÀNG / Đơn thường";
/** Quản lý đơn hàng — đơn VAT (lineId = 12). */
export const ORDERS_VAT_DIVISION_FEATURE = "ĐƠN HÀNG / Đơn VAT";
/** @deprecated JSON cũ — một cờ view; đọc kèm {@link ORDERS_MUA_HO_NORMAL_DIVISION_FEATURE} / VAT. */
export const ORDERS_MUA_HO_DIVISION_FEATURE = "ĐƠN HÀNG / Mua hộ";
/** Đơn hàng mua hộ — đơn line thường. */
export const ORDERS_MUA_HO_NORMAL_DIVISION_FEATURE = "ĐƠN HÀNG / Đơn hàng mua hộ / Đơn thường";
/** Đơn hàng mua hộ — đơn VAT. */
export const ORDERS_MUA_HO_VAT_DIVISION_FEATURE = "ĐƠN HÀNG / Đơn hàng mua hộ / Đơn VAT";

/** Cột hiển thị — mã bao / mã vận đơn (chỉ cờ view). */
export const ORDER_DISPLAY_SACK_CODE_FEATURE = "ĐƠN HÀNG / Mã bao";
export const ORDER_DISPLAY_CN_SHIPPING_CODE_FEATURE = "ĐƠN HÀNG / Mã vận đơn TQ";
export const ORDER_DISPLAY_VN_SHIPPING_CODE_FEATURE = "ĐƠN HÀNG / Mã vận đơn VN";

/** Ánh xạ quyền phòng ban → khóa cột trên danh sách đơn hàng. */
export const ORDER_DISPLAY_COLUMN_PERMISSION_MAP = [
  { feature: ORDER_DISPLAY_SACK_CODE_FEATURE, columnKey: "sackCode" },
  { feature: ORDER_DISPLAY_CN_SHIPPING_CODE_FEATURE, columnKey: "cnShippingCode" },
  { feature: ORDER_DISPLAY_VN_SHIPPING_CODE_FEATURE, columnKey: "vnShippingCode" },
  { feature: "ĐƠN HÀNG / Đối soát KH", columnKey: "customerChecking" },
  // "ĐS KH gốc" đi cùng quyền xem "Đối soát KH".
  { feature: "ĐƠN HÀNG / Đối soát KH", columnKey: "customerFeeOriginal" },
  { feature: "ĐƠN HÀNG / Mã ĐT", columnKey: "partnerCode" },
  { feature: "ĐƠN HÀNG / Đối soát ĐT", columnKey: "contactFee" },
  { feature: "ĐƠN HÀNG / Lợi nhuận", columnKey: "profit" },
];

/** Cột hiển thị trên danh sách đơn (mua hộ + vận chuyển) — chỉ cờ view trong JSON phòng ban. */
export const ORDER_RECONCILE_COLUMN_FEATURES = [...new Set(ORDER_DISPLAY_COLUMN_PERMISSION_MAP.map((r) => r.feature))];

/**
 * Cột ẩn theo quyền phòng ban (member không có cờ view tương ứng).
 * @param {{ feature?: string, view?: boolean }[]} permissionRows
 * @returns {string[]}
 */
export function resolveOrderPermissionHiddenColumnKeys(permissionRows) {
  const allowedSet = new Set(
    (permissionRows || [])
      .filter((p) => p?.view)
      .map((p) => normalizeDivisionFeatureName(p?.feature))
      .filter(Boolean)
  );
  const hidden = [];
  for (const { feature, columnKey } of ORDER_DISPLAY_COLUMN_PERMISSION_MAP) {
    if (!allowedSet.has(normalizeDivisionFeatureName(feature))) {
      hidden.push(columnKey);
    }
  }
  return hidden;
}

/** Xuất file Excel trên màn quản lý đơn (từng mục chỉ dùng cờ view). Khớp dropdown Excel trong OrderAdmin. */
export const ORDER_EXCEL_EXPORT_FEATURES = [
  "ĐƠN HÀNG / Xuất BG MH thường",
  "ĐƠN HÀNG / Xuất BG MH VAT",
  "ĐƠN HÀNG / Xuất hồ sơ thường",
  "ĐƠN HÀNG / Xuất hồ sơ VAT",
  "ĐƠN HÀNG / Xuất đối soát VAT nháp",
  "ĐƠN HÀNG / Báo giá vận chuyển thường",
  "ĐƠN HÀNG / Báo giá vận chuyển VAT",
];

/** Cập nhật nhanh (dropdown FaSyncAlt): từng mục chỉ cờ view — khớp từng nhóm trong OrderAdmin. */
export const ORDER_QUICK_UPDATE_PROGRESS_FEATURE = "ĐƠN HÀNG / Lưu trình";
export const ORDER_QUICK_UPDATE_CHECKING_FEATURE = "ĐƠN HÀNG / Đối soát khách hàng";
export const ORDER_QUICK_UPDATE_CONTACTING_FEATURE = "ĐƠN HÀNG / Đối soát đối tác";
export const ORDER_QUICK_UPDATE_LOCKING_FEATURE = "ĐƠN HÀNG / Khóa đơn hàng";
export const ORDER_QUICK_UPDATE_SACK_CODE_FEATURE = "ĐƠN HÀNG / Cập nhật mã bao";
export const ORDER_QUICK_UPDATE_RECALCULATE_FEE_FEATURE = "ĐƠN HÀNG / Tính toán lại chi phí";

/** @deprecated JSON cũ (một dòng); đọc trong fetchOrdersDivisionPermissions để không mất quyền. */
export const ORDER_QUICK_UPDATE_LEGACY_SINGLE_FEATURE = "ĐƠN HÀNG / Cập nhật nhanh";

/** Khóa JSON cũ «… / Cập nhật nhanh - …» → khóa mới (nhãn ngắn). */
export const ORDER_QUICK_UPDATE_FEATURE_KEY_MIGRATION = {
  "ĐƠN HÀNG / Cập nhật nhanh - Lưu trình": ORDER_QUICK_UPDATE_PROGRESS_FEATURE,
  "ĐƠN HÀNG / Cập nhật nhanh - Đối soát khách hàng": ORDER_QUICK_UPDATE_CHECKING_FEATURE,
  "ĐƠN HÀNG / Cập nhật nhanh - Đối soát đối tác": ORDER_QUICK_UPDATE_CONTACTING_FEATURE,
  "ĐƠN HÀNG / Cập nhật nhanh - Khóa đơn hàng": ORDER_QUICK_UPDATE_LOCKING_FEATURE,
  "ĐƠN HÀNG / Cập nhật nhanh - Cập nhật mã bao": ORDER_QUICK_UPDATE_SACK_CODE_FEATURE,
  "ĐƠN HÀNG / Cập nhật nhanh - Cập nhật lại bảng giá": ORDER_QUICK_UPDATE_RECALCULATE_FEE_FEATURE,
  "ĐƠN HÀNG / Cập nhật lại bảng giá": ORDER_QUICK_UPDATE_RECALCULATE_FEE_FEATURE,
};

/** Chuẩn hóa feature lưu trong JSON bộ phận (đồng bộ tên cũ). */
export function migrateDivisionQuickUpdateFeatureKey(feature) {
  if (feature == null || feature === "") return feature;
  const n = normalizeDivisionFeatureName(feature);
  for (const [oldKey, newKey] of Object.entries(ORDER_QUICK_UPDATE_FEATURE_KEY_MIGRATION)) {
    if (normalizeDivisionFeatureName(oldKey) === n) {
      return newKey;
    }
  }
  return feature;
}

export const ORDER_QUICK_UPDATE_FEATURES = [
  ORDER_QUICK_UPDATE_PROGRESS_FEATURE,
  ORDER_QUICK_UPDATE_CHECKING_FEATURE,
  ORDER_QUICK_UPDATE_CONTACTING_FEATURE,
  ORDER_QUICK_UPDATE_LOCKING_FEATURE,
  ORDER_QUICK_UPDATE_SACK_CODE_FEATURE,
  ORDER_QUICK_UPDATE_RECALCULATE_FEE_FEATURE,
];

/** Hiển thị menu Đơn hàng khi có quyền xem bất kỳ mục con / cốt / cột nào. */
export const ORDER_DIVISION_MENU_VIEW_FEATURES = [
  ORDER_DIVISION_FEATURE,
  ORDERS_NORMAL_DIVISION_FEATURE,
  ORDERS_VAT_DIVISION_FEATURE,
  ORDERS_MUA_HO_DIVISION_FEATURE,
  ORDERS_MUA_HO_NORMAL_DIVISION_FEATURE,
  ORDERS_MUA_HO_VAT_DIVISION_FEATURE,
  ...ORDER_EXCEL_EXPORT_FEATURES,
  ...ORDER_QUICK_UPDATE_FEATURES,
  ...ORDER_RECONCILE_COLUMN_FEATURES,
];

export const RECONCILE_NORMAL_CUSTOMERS_DIVISION_FEATURE = "ĐỐI SOÁT / Khách hàng thường";
/** Đối soát → Khách hàng VAT (#/doi-soat-don-hang); khớp BackendHeader.canViewReconcileVat */
export const RECONCILE_VAT_CUSTOMERS_DIVISION_FEATURE = "ĐỐI SOÁT / Khách hàng VAT";
export const RECONCILE_PARTNER_NORMAL_DIVISION_FEATURE = "ĐỐI SOÁT / Đối tác thường";
export const RECONCILE_PARTNER_VAT_DIVISION_FEATURE = "ĐỐI SOÁT / Đối tác VAT";

/**
 * Quyền màn đơn hàng VAT đã giao / tạo đối soát: admin full; member theo {@link RECONCILE_VAT_CUSTOMERS_DIVISION_FEATURE}.
 * @param {import('axios').AxiosInstance} axiosInstance
 */
export async function fetchReconcileVatCustomerPermissions(axiosInstance) {
  try {
    const flagsRes = await axiosInstance.get("/api/users/myFlags");
    const flags = flagsRes?.data?.data || {};
    if (flags?.isAdmin === true) {
      return { canView: true, canCreate: true, canEdit: true, canDelete: true };
    }
    if (flags?.isMember === true) {
      const permRes = await axiosInstance.get("/api/users/myDivisionPermissions");
      const rows = permRes?.data?.data || [];
      const target = normalizeDivisionFeatureName(RECONCILE_VAT_CUSTOMERS_DIVISION_FEATURE);
      const row = rows.find((p) => normalizeDivisionFeatureName(p?.feature) === target);
      return {
        canView: Boolean(row?.view),
        canCreate: Boolean(row?.create),
        canEdit: Boolean(row?.edit),
        canDelete: Boolean(row?.delete),
      };
    }
    return { canView: true, canCreate: true, canEdit: true, canDelete: true };
  } catch {
    return { canView: true, canCreate: true, canEdit: true, canDelete: true };
  }
}

/**
 * Quyền màn quản lý đối soát khách hàng thường (/quan-li-doi-soat).
 * @param {import('axios').AxiosInstance} axiosInstance
 */
export async function fetchReconcileNormalCustomerPermissions(axiosInstance) {
  try {
    const flagsRes = await axiosInstance.get("/api/users/myFlags");
    const flags = flagsRes?.data?.data || {};
    if (flags?.isAdmin === true) {
      return { canView: true, canCreate: true, canEdit: true, canDelete: true };
    }
    if (flags?.isMember === true) {
      const permRes = await axiosInstance.get("/api/users/myDivisionPermissions");
      const rows = permRes?.data?.data || [];
      const target = normalizeDivisionFeatureName(RECONCILE_NORMAL_CUSTOMERS_DIVISION_FEATURE);
      const row = rows.find((p) => normalizeDivisionFeatureName(p?.feature) === target);
      return {
        canView: Boolean(row?.view),
        canCreate: Boolean(row?.create),
        canEdit: Boolean(row?.edit),
        canDelete: Boolean(row?.delete),
      };
    }
    return { canView: true, canCreate: true, canEdit: true, canDelete: true };
  } catch {
    return { canView: true, canCreate: true, canEdit: true, canDelete: true };
  }
}

/**
 * Quyền màn đối soát Đối tác thường (/don-hang-doi-tac).
 * @param {import('axios').AxiosInstance} axiosInstance
 */
export async function fetchReconcilePartnerNormalPermissions(axiosInstance) {
  try {
    const flagsRes = await axiosInstance.get("/api/users/myFlags");
    const flags = flagsRes?.data?.data || {};
    if (flags?.isAdmin === true) {
      return { canView: true, canCreate: true, canEdit: true };
    }
    if (flags?.isMember === true) {
      const permRes = await axiosInstance.get("/api/users/myDivisionPermissions");
      const rows = permRes?.data?.data || [];
      const target = normalizeDivisionFeatureName(RECONCILE_PARTNER_NORMAL_DIVISION_FEATURE);
      const row = rows.find((p) => normalizeDivisionFeatureName(p?.feature) === target);
      return {
        canView: Boolean(row?.view),
        canCreate: Boolean(row?.create),
        canEdit: Boolean(row?.edit),
      };
    }
    return { canView: true, canCreate: true, canEdit: true };
  } catch {
    return { canView: true, canCreate: true, canEdit: true };
  }
}

/**
 * Quyền màn đối soát Đối tác VAT (/don-hang-vat-doi-tac).
 * @param {import('axios').AxiosInstance} axiosInstance
 */
export async function fetchReconcilePartnerVatPermissions(axiosInstance) {
  try {
    const flagsRes = await axiosInstance.get("/api/users/myFlags");
    const flags = flagsRes?.data?.data || {};
    if (flags?.isAdmin === true) {
      return { canView: true, canCreate: true, canEdit: true };
    }
    if (flags?.isMember === true) {
      const permRes = await axiosInstance.get("/api/users/myDivisionPermissions");
      const rows = permRes?.data?.data || [];
      const target = normalizeDivisionFeatureName(RECONCILE_PARTNER_VAT_DIVISION_FEATURE);
      const row = rows.find((p) => normalizeDivisionFeatureName(p?.feature) === target);
      return {
        canView: Boolean(row?.view),
        canCreate: Boolean(row?.create),
        canEdit: Boolean(row?.edit),
      };
    }
    return { canView: true, canCreate: true, canEdit: true };
  } catch {
    return { canView: true, canCreate: true, canEdit: true };
  }
}

/**
 * Quyền chức năng Khách hàng trên menu phòng ban: admin full; member theo từng cột.
 * @param {import('axios').AxiosInstance} axiosInstance
 */
export async function fetchCustomerMenuPermissions(axiosInstance) {
  try {
    const flagsRes = await axiosInstance.get("/api/users/myFlags");
    const flags = flagsRes?.data?.data || {};
    if (flags?.isAdmin === true) {
      return { canView: true, canCreate: true, canEdit: true };
    }
    if (flags?.isMember === true) {
      const permRes = await axiosInstance.get("/api/users/myDivisionPermissions");
      const rows = permRes?.data?.data || [];
      const target = normalizeDivisionFeatureName(CUSTOMERS_DIVISION_FEATURE);
      const row = rows.find((p) => normalizeDivisionFeatureName(p?.feature) === target);
      const filterPerms = resolveCustomerFilterPermissionsFromRows(rows);
      const filterAny = Object.values(filterPerms.byGroup).some(Boolean);
      const canView =
        Boolean(row?.view) ||
        Boolean(row?.create) ||
        Boolean(row?.edit) ||
        (filterPerms.hasGranular && filterAny);
      return {
        canView,
        canCreate: Boolean(row?.create),
        canEdit: Boolean(row?.edit),
      };
    }
    return { canView: true, canCreate: true, canEdit: true };
  } catch {
    return { canView: true, canCreate: true, canEdit: true };
  }
}

/**
 * Quyền hiển thị từng nút lọc trên Danh sách khách hàng.
 * Admin: tất cả; member: chỉ khi cờ view của từng mục con được bật (mặc định ẩn).
 * @returns {{ byGroup: Record<string, boolean>, hasGranular: boolean }}
 */
export function resolveCustomerFilterPermissionsFromRows(rows) {
  const byNorm = new Map();
  for (const r of rows || []) {
    if (!r?.feature) continue;
    byNorm.set(normalizeDivisionFeatureName(r.feature), r);
  }
  const hasGranular = CUSTOMER_FILTER_DIVISION_FEATURES.some((f) =>
    byNorm.has(normalizeDivisionFeatureName(f))
  );
  /** @type {Record<string, boolean>} */
  const byGroup = {};
  for (const groupName of CUSTOMER_FILTER_GROUP_NAMES) {
    const feat = customerFilterGroupToFeature(groupName);
    const row = byNorm.get(normalizeDivisionFeatureName(feat));
    byGroup[groupName] = Boolean(row?.view);
  }
  return { byGroup, hasGranular };
}

export async function fetchCustomerListPermissions(axiosInstance) {
  const fullFilter = () => ({
    byGroup: Object.fromEntries(CUSTOMER_FILTER_GROUP_NAMES.map((g) => [g, true])),
    hasGranular: false,
  });
  const full = () => ({
    canCreate: true,
    filter: fullFilter(),
  });
  try {
    const flagsRes = await axiosInstance.get("/api/users/myFlags");
    const flags = flagsRes?.data?.data || {};
    if (flags?.isAdmin === true) {
      return full();
    }
    if (flags?.isMember === true) {
      const permRes = await axiosInstance.get("/api/users/myDivisionPermissions");
      const rows = permRes?.data?.data || [];
      const target = normalizeDivisionFeatureName(CUSTOMERS_DIVISION_FEATURE);
      const row = rows.find((p) => normalizeDivisionFeatureName(p?.feature) === target);
      return {
        canCreate: Boolean(row?.create),
        filter: resolveCustomerFilterPermissionsFromRows(rows),
      };
    }
    return full();
  } catch {
    return full();
  }
}

export async function fetchCustomerFilterPermissions(axiosInstance) {
  const bundle = await fetchCustomerListPermissions(axiosInstance);
  return bundle.filter;
}

/**
 * Quyền thêm khách mới: admin luôn được; member theo cột create của chức năng Khách hàng.
 */
export async function fetchCanCreateCustomer(axiosInstance) {
  const bundle = await fetchCustomerListPermissions(axiosInstance);
  return bundle.canCreate;
}

/**
 * Quyền chức năng Đối tác trên menu phòng ban: admin full; member theo từng cột.
 * @param {import('axios').AxiosInstance} axiosInstance
 */
export async function fetchPartnerMenuPermissions(axiosInstance) {
  try {
    const flagsRes = await axiosInstance.get("/api/users/myFlags");
    const flags = flagsRes?.data?.data || {};
    if (flags?.isAdmin === true) {
      return { canView: true, canCreate: true, canEdit: true, canDelete: true };
    }
    if (flags?.isMember === true) {
      const permRes = await axiosInstance.get("/api/users/myDivisionPermissions");
      const rows = permRes?.data?.data || [];
      const target = normalizeDivisionFeatureName(PARTNERS_DIVISION_FEATURE);
      const row = rows.find((p) => normalizeDivisionFeatureName(p?.feature) === target);
      return {
        canView: Boolean(row?.view),
        canCreate: Boolean(row?.create),
        canEdit: Boolean(row?.edit),
        canDelete: Boolean(row?.delete),
      };
    }
    return { canView: true, canCreate: true, canEdit: true, canDelete: false };
  } catch {
    return { canView: true, canCreate: true, canEdit: true, canDelete: false };
  }
}

/**
 * Quyền thêm đối tác mới: admin luôn được; member theo cột create của chức năng Đối tác.
 */
export async function fetchCanCreatePartner(axiosInstance) {
  const p = await fetchPartnerMenuPermissions(axiosInstance);
  return p.canCreate;
}

/**
 * Quyền chức năng Danh mục trên menu phòng ban: admin full; member theo từng cột.
 * @param {import('axios').AxiosInstance} axiosInstance
 */
export async function fetchCategoryMenuPermissions(axiosInstance) {
  try {
    const flagsRes = await axiosInstance.get("/api/users/myFlags");
    const flags = flagsRes?.data?.data || {};
    if (flags?.isAdmin === true) {
      return { canView: true, canCreate: true, canEdit: true };
    }
    if (flags?.isMember === true) {
      const permRes = await axiosInstance.get("/api/users/myDivisionPermissions");
      const rows = permRes?.data?.data || [];
      const target = normalizeDivisionFeatureName(CATEGORIES_DIVISION_FEATURE);
      const row = rows.find((p) => normalizeDivisionFeatureName(p?.feature) === target);
      return {
        canView: Boolean(row?.view),
        canCreate: Boolean(row?.create),
        canEdit: Boolean(row?.edit),
      };
    }
    return { canView: true, canCreate: true, canEdit: true };
  } catch {
    return { canView: true, canCreate: true, canEdit: true };
  }
}

/**
 * User có quyền xem ít nhất một màn Kế toán (menu).
 * @param {import('axios').AxiosInstance} axiosInstance
 */
export async function canViewAnyAccounting(axiosInstance) {
  try {
    const flagsRes = await axiosInstance.get("/api/users/myFlags");
    const flags = flagsRes?.data?.data || {};
    if (flags?.isAdmin === true) return true;
    if (flags?.isMember !== true) return false;

    const permRes = await axiosInstance.get("/api/users/myDivisionPermissions");
    const rows = permRes?.data?.data || [];
    return canViewAnyAccountingInRows(rows);
  } catch {
    return false;
  }
}

/**
 * User được xem Dashboard tài chính (= có đủ toàn bộ quyền Báo cáo kế toán).
 * @param {import('axios').AxiosInstance} axiosInstance
 */
export async function canViewAccountingReports(axiosInstance) {
  try {
    const flagsRes = await axiosInstance.get("/api/users/myFlags");
    const flags = flagsRes?.data?.data || {};
    if (flags?.isAdmin === true) return true;
    if (flags?.isMember !== true) return false;

    const permRes = await axiosInstance.get("/api/users/myDivisionPermissions");
    const rows = permRes?.data?.data || [];
    return canViewAccountingReportsInRows(rows);
  } catch {
    return false;
  }
}

/**
 * Quyền màn hình kế toán theo feature key (leaf hoặc nhóm legacy).
 * @param {import('axios').AxiosInstance} axiosInstance
 * @param {string} featureKey
 */
export async function fetchAccountingPermissions(axiosInstance, featureKey) {
  try {
    const flagsRes = await axiosInstance.get("/api/users/myFlags");
    const flags = flagsRes?.data?.data || {};
    if (flags?.isAdmin === true) {
      return { canView: true, canCreate: true, canEdit: true, canDelete: true };
    }
    if (flags?.isMember === true) {
      const permRes = await axiosInstance.get("/api/users/myDivisionPermissions");
      const rows = permRes?.data?.data || [];
      return {
        canView: hasAccountingPermissionInRows(rows, featureKey, "view"),
        canCreate: hasAccountingPermissionInRows(rows, featureKey, "create"),
        canEdit: hasAccountingPermissionInRows(rows, featureKey, "edit"),
        canDelete: hasAccountingPermissionInRows(rows, featureKey, "delete"),
      };
    }
    return { canView: false, canCreate: false, canEdit: false, canDelete: false };
  } catch {
    return { canView: false, canCreate: false, canEdit: false, canDelete: false };
  }
}

export const WAREHOUSE_FEATURE_GROUP = "KHO VẬN";
export const WAREHOUSE_SCAN_IN_FEATURE = "KHO VẬN / Quét nhập kho VN";
export const WAREHOUSE_SCAN_OUT_FEATURE = "KHO VẬN / Quét xuất kho VN";
export const WAREHOUSE_UNCLAIMED_FEATURE = "KHO VẬN / Đơn vô chủ";
export const WAREHOUSE_FEATURES = [
  WAREHOUSE_SCAN_IN_FEATURE,
  WAREHOUSE_SCAN_OUT_FEATURE,
  WAREHOUSE_UNCLAIMED_FEATURE,
];

/**
 * Quyền module Kho Vận (khớp WarehousePermissionService ở backend): admin full; member theo dòng
 * của chức năng hoặc của cả nhóm «KHO VẬN»; khách hàng không có quyền.
 * @param {import('axios').AxiosInstance} axiosInstance
 * @param {string} featureKey
 */
export async function fetchWarehousePermissions(axiosInstance, featureKey) {
  const none = { canView: false, canCreate: false, canEdit: false, canDelete: false };
  try {
    const flagsRes = await axiosInstance.get("/api/users/myFlags");
    const flags = flagsRes?.data?.data || {};
    if (flags?.isAdmin === true) {
      return { canView: true, canCreate: true, canEdit: true, canDelete: true };
    }
    if (flags?.isMember !== true) return none;
    const permRes = await axiosInstance.get("/api/users/myDivisionPermissions");
    const rows = permRes?.data?.data || [];
    const targets = [featureKey, WAREHOUSE_FEATURE_GROUP].map(normalizeDivisionFeatureName);
    const matched = rows.filter((p) => targets.includes(normalizeDivisionFeatureName(p?.feature)));
    return {
      canView: matched.some((p) => p?.view),
      canCreate: matched.some((p) => p?.create),
      canEdit: matched.some((p) => p?.edit),
      canDelete: matched.some((p) => p?.delete),
    };
  } catch {
    return none;
  }
}

/**
 * Quyền chức năng Nhà cung cấp trên menu phòng ban: admin full; member theo từng cột.
 * @param {import('axios').AxiosInstance} axiosInstance
 */
export async function fetchProviderMenuPermissions(axiosInstance) {
  try {
    const flagsRes = await axiosInstance.get("/api/users/myFlags");
    const flags = flagsRes?.data?.data || {};
    if (flags?.isAdmin === true) {
      return { canView: true, canCreate: true, canEdit: true };
    }
    if (flags?.isMember === true) {
      const permRes = await axiosInstance.get("/api/users/myDivisionPermissions");
      const rows = permRes?.data?.data || [];
      const target = normalizeDivisionFeatureName(PROVIDERS_DIVISION_FEATURE);
      const row = rows.find((p) => normalizeDivisionFeatureName(p?.feature) === target);
      return {
        canView: Boolean(row?.view),
        canCreate: Boolean(row?.create),
        canEdit: Boolean(row?.edit),
      };
    }
    return { canView: true, canCreate: true, canEdit: true };
  } catch {
    return { canView: true, canCreate: true, canEdit: true };
  }
}

/**
 * Quyền «Đánh giá - bình luận» (vote / gửi bình luận tại chi tiết NCC): cờ view trên phòng ban.
 * Admin: luôn được; member: theo {@link PROVIDER_RATING_COMMENT_DIVISION_FEATURE}.
 * @param {import('axios').AxiosInstance} axiosInstance
 */
export async function fetchProviderRatingCommentPermissions(axiosInstance) {
  try {
    const flagsRes = await axiosInstance.get("/api/users/myFlags");
    const flags = flagsRes?.data?.data || {};
    if (flags?.isAdmin === true) {
      return { canCommentVote: true };
    }
    if (flags?.isMember === true) {
      const permRes = await axiosInstance.get("/api/users/myDivisionPermissions");
      const rows = permRes?.data?.data || [];
      const target = normalizeDivisionFeatureName(PROVIDER_RATING_COMMENT_DIVISION_FEATURE);
      const row = rows.find((p) => normalizeDivisionFeatureName(p?.feature) === target);
      return { canCommentVote: Boolean(row?.view) };
    }
    return { canCommentVote: true };
  } catch {
    return { canCommentVote: true };
  }
}

/**
 * Phân quyền nhóm THÔNG BÁO (nhắc đánh giá NCC, inbox / xử lý yêu cầu chuyển đơn).
 * Admin: full; member: cờ view từng dòng trên JSON phòng ban.
 * @param {import('axios').AxiosInstance} axiosInstance
 */
export async function fetchNotificationDivisionPermissions(axiosInstance) {
  try {
    const flagsRes = await axiosInstance.get("/api/users/myFlags");
    const flags = flagsRes?.data?.data || {};
    if (flags?.isAdmin === true) {
      return {
        nccRatingReminder: true,
        transferRequestInbox: true,
        transferRequestProcess: true,
      };
    }
    if (flags?.isMember === true) {
      const permRes = await axiosInstance.get("/api/users/myDivisionPermissions");
      const rows = permRes?.data?.data || [];
      const rowView = (feat) => {
        const t = normalizeDivisionFeatureName(feat);
        const row = rows.find((p) => normalizeDivisionFeatureName(p?.feature) === t);
        return Boolean(row?.view);
      };
      return {
        nccRatingReminder: rowView(NOTIFY_NCC_RATING_REMINDER_FEATURE),
        transferRequestInbox: rowView(NOTIFY_TRANSFER_REQUEST_INBOX_FEATURE),
        transferRequestProcess: rowView(NOTIFY_TRANSFER_REQUEST_PROCESS_FEATURE),
      };
    }
    return {
      nccRatingReminder: true,
      transferRequestInbox: true,
      transferRequestProcess: true,
    };
  } catch {
    return {
      nccRatingReminder: true,
      transferRequestInbox: true,
      transferRequestProcess: true,
    };
  }
}

function findDivisionPermissionRow(rows, ...featureNames) {
  for (const name of featureNames) {
    const t = normalizeDivisionFeatureName(name);
    const row = rows.find((p) => normalizeDivisionFeatureName(p?.feature) === t);
    if (row) return row;
  }
  return null;
}

/**
 * Quyền chi tiết màn /products: SP cá nhân, SP dùng chung, xuất Excel (member + JSON cũ).
 * @param {import('axios').AxiosInstance} axiosInstance
 */
export async function fetchProductsDivisionPermissions(axiosInstance) {
  const fullAccess = () => ({
    personal: { view: true, create: true, edit: true, delete: true },
    shared: { view: true, create: true, edit: true, delete: true },
    exportExcel: true,
  });
  try {
    const flagsRes = await axiosInstance.get("/api/users/myFlags");
    const flags = flagsRes?.data?.data || {};
    if (flags?.isAdmin === true) return fullAccess();
    if (flags?.isMember !== true) return fullAccess();

    const permRes = await axiosInstance.get("/api/users/myDivisionPermissions");
    const rows = permRes?.data?.data || [];

    const legacyMain = findDivisionPermissionRow(rows, PRODUCTS_DIVISION_FEATURE_LEGACY);
    const personalRow = findDivisionPermissionRow(rows, PRODUCTS_PERSONAL_DIVISION_FEATURE);
    const sharedRow = findDivisionPermissionRow(rows, PRODUCTS_SHARED_DIVISION_FEATURE);
    const legacyPer = findDivisionPermissionRow(rows, PRODUCTS_ADD_PERSONAL_LEGACY);
    const legacyShr = findDivisionPermissionRow(rows, PRODUCTS_ADD_SHARED_LEGACY);
    const exportRow = findDivisionPermissionRow(rows, PRODUCTS_EXPORT_EXCEL_DIVISION_FEATURE);

    /** Đã có dòng SẢN PHẨM / SP cá nhân hoặc dùng chung trong JSON → không fallback legacy cho nhánh không có dòng. */
    const hasGranularProductRows = personalRow != null || sharedRow != null;

    const personal = {
      view: hasGranularProductRows
        ? Boolean(personalRow?.view)
        : Boolean(personalRow?.view ?? legacyMain?.view),
      create: Boolean(personalRow?.create ?? legacyPer?.view ?? legacyMain?.create),
      edit: Boolean(personalRow?.edit ?? legacyMain?.edit),
      delete: Boolean(personalRow?.delete ?? legacyMain?.delete),
    };
    const shared = {
      view: hasGranularProductRows
        ? Boolean(sharedRow?.view)
        : Boolean(sharedRow?.view ?? legacyMain?.view),
      create: Boolean(sharedRow?.create ?? legacyShr?.view ?? legacyMain?.create),
      edit: Boolean(sharedRow?.edit ?? legacyMain?.edit),
      delete: Boolean(sharedRow?.delete ?? legacyMain?.delete),
    };
    const exportExcel = Boolean(exportRow?.view);

    return { personal, shared, exportExcel };
  } catch {
    return fullAccess();
  }
}

/**
 * Quyền gộp cho ProductEditor / menu (OR giữa SP cá nhân và dùng chung).
 * @param {import('axios').AxiosInstance} axiosInstance
 */
export async function fetchProductMenuPermissions(axiosInstance) {
  const b = await fetchProductsDivisionPermissions(axiosInstance);
  return {
    canView: b.personal.view || b.shared.view,
    canCreate: b.personal.create || b.shared.create,
    canEdit: b.personal.edit || b.shared.edit,
    canDelete: b.personal.delete || b.shared.delete,
  };
}

/**
 * Quyền màn Phân quyền (menu Hệ thống): admin full; member theo từng cột.
 * @param {import('axios').AxiosInstance} axiosInstance
 */
export async function fetchDepartmentMenuPermissions(axiosInstance) {
  try {
    const flagsRes = await axiosInstance.get("/api/users/myFlags");
    const flags = flagsRes?.data?.data || {};
    if (flags?.isAdmin === true) {
      return { canView: true, canCreate: true, canEdit: true, canDelete: true };
    }
    if (flags?.isMember === true) {
      const permRes = await axiosInstance.get("/api/users/myDivisionPermissions");
      const rows = permRes?.data?.data || [];
      const targetNew = normalizeDivisionFeatureName(DEPARTMENTS_DIVISION_FEATURE);
      const targetLegacy = normalizeDivisionFeatureName(DEPARTMENTS_DIVISION_FEATURE_LEGACY);
      const row =
        rows.find((p) => normalizeDivisionFeatureName(p?.feature) === targetNew) ||
        rows.find((p) => normalizeDivisionFeatureName(p?.feature) === targetLegacy);
      return {
        canView: Boolean(row?.view),
        canCreate: Boolean(row?.create),
        canEdit: Boolean(row?.edit),
        canDelete: Boolean(row?.delete),
      };
    }
    return { canView: true, canCreate: true, canEdit: true, canDelete: true };
  } catch {
    return { canView: true, canCreate: true, canEdit: true, canDelete: true };
  }
}

/**
 * Quyền màn Cài đặt hệ thống (/cai-dat-he-thong):
 * admin full; member theo chức năng MỞ RỘNG / Cài đặt hệ thống.
 * @param {import('axios').AxiosInstance} axiosInstance
 */
export async function fetchSystemSettingsPermissions(axiosInstance) {
  try {
    const flagsRes = await axiosInstance.get("/api/users/myFlags");
    const flags = flagsRes?.data?.data || {};
    if (flags?.isAdmin === true) {
      return { canView: true, canEdit: true };
    }
    if (flags?.isMember === true) {
      const permRes = await axiosInstance.get("/api/users/myDivisionPermissions");
      const rows = permRes?.data?.data || [];
      const target = normalizeDivisionFeatureName(SYSTEM_SETTINGS_DIVISION_FEATURE);
      const row = rows.find((p) => normalizeDivisionFeatureName(p?.feature) === target);
      return {
        canView: Boolean(row?.view),
        canEdit: Boolean(row?.edit),
      };
    }
    return { canView: false, canEdit: false };
  } catch {
    return { canView: false, canEdit: false };
  }
}

/**
 * Quyền nhóm Cài đặt (setting-progress, setting, order-setting, ranking-setting):
 * admin full; member theo chức năng MỞ RỘNG / Cài đặt.
 * @param {import('axios').AxiosInstance} axiosInstance
 */
export async function fetchSettingsPermissions(axiosInstance) {
  try {
    const flagsRes = await axiosInstance.get("/api/users/myFlags");
    const flags = flagsRes?.data?.data || {};
    if (flags?.isAdmin === true) {
      return { canView: true, canCreate: true, canEdit: true, canDelete: true };
    }
    if (flags?.isMember === true) {
      const permRes = await axiosInstance.get("/api/users/myDivisionPermissions");
      const rows = permRes?.data?.data || [];
      const target = normalizeDivisionFeatureName("MỞ RỘNG / Cài đặt");
      const row = rows.find((p) => normalizeDivisionFeatureName(p?.feature) === target);
      return {
        canView: Boolean(row?.view),
        canCreate: Boolean(row?.create),
        canEdit: Boolean(row?.edit),
        canDelete: Boolean(row?.delete),
      };
    }
    return { canView: true, canCreate: true, canEdit: true, canDelete: true };
  } catch {
    return { canView: true, canCreate: true, canEdit: true, canDelete: true };
  }
}

/**
 * Quyền màn Website / Liên hệ khách hàng (/contact-exploration): admin full; member theo từng cột.
 * @param {import('axios').AxiosInstance} axiosInstance
 */
export async function fetchWebsiteContactPermissions(axiosInstance) {
  try {
    const flagsRes = await axiosInstance.get("/api/users/myFlags");
    const flags = flagsRes?.data?.data || {};
    if (flags?.isAdmin === true) {
      return { canView: true, canCreate: true, canEdit: true, canDelete: true };
    }
    if (flags?.isMember === true) {
      const permRes = await axiosInstance.get("/api/users/myDivisionPermissions");
      const rows = permRes?.data?.data || [];
      const target = normalizeDivisionFeatureName(WEBSITE_CONTACT_DIVISION_FEATURE);
      const row = rows.find((p) => normalizeDivisionFeatureName(p?.feature) === target);
      return {
        canView: Boolean(row?.view),
        canCreate: Boolean(row?.create),
        canEdit: Boolean(row?.edit),
        canDelete: Boolean(row?.delete),
      };
    }
    return { canView: true, canCreate: true, canEdit: true, canDelete: true };
  } catch {
    return { canView: true, canCreate: true, canEdit: true, canDelete: true };
  }
}

/**
 * Quyền màn Website / Quản lý bài viết (/admin/news-list): admin full; member theo từng cột.
 * @param {import('axios').AxiosInstance} axiosInstance
 */
export async function fetchWebsiteNewsPermissions(axiosInstance) {
  try {
    const flagsRes = await axiosInstance.get("/api/users/myFlags");
    const flags = flagsRes?.data?.data || {};
    if (flags?.isAdmin === true) {
      return { canView: true, canCreate: true, canEdit: true, canDelete: true };
    }
    if (flags?.isMember === true) {
      const permRes = await axiosInstance.get("/api/users/myDivisionPermissions");
      const rows = permRes?.data?.data || [];
      const target = normalizeDivisionFeatureName(WEBSITE_NEWS_DIVISION_FEATURE);
      const row = rows.find((p) => normalizeDivisionFeatureName(p?.feature) === target);
      return {
        canView: Boolean(row?.view),
        canCreate: Boolean(row?.create),
        canEdit: Boolean(row?.edit),
        canDelete: Boolean(row?.delete),
      };
    }
    return { canView: true, canCreate: true, canEdit: true, canDelete: true };
  } catch {
    return { canView: true, canCreate: true, canEdit: true, canDelete: true };
  }
}

/**
 * Quyền màn Chat admin (/admin/chat-inbox): nếu có quyền xem thì được full thao tác trong màn.
 * @param {import('axios').AxiosInstance} axiosInstance
 */
export async function fetchChatPermissions(axiosInstance) {
  try {
    const flagsRes = await axiosInstance.get("/api/users/myFlags");
    const flags = flagsRes?.data?.data || {};
    if (flags?.isAdmin === true) {
      return { canView: true, canCreate: true, canEdit: true, canDelete: true };
    }
    if (flags?.isMember === true) {
      const permRes = await axiosInstance.get("/api/users/myDivisionPermissions");
      const rows = permRes?.data?.data || [];
      const hasCskh = CSKH_DIVISION_FEATURES.some((feature) => {
        const target = normalizeDivisionFeatureName(feature);
        return rows.some((p) => normalizeDivisionFeatureName(p?.feature) === target && p?.view);
      });
      const legacyChat = rows.some(
        (p) => normalizeDivisionFeatureName(p?.feature) === normalizeDivisionFeatureName(CHAT_DIVISION_FEATURE) && p?.view
      );
      const canView = hasCskh || legacyChat;
      return {
        canView,
        canCreate: canView,
        canEdit: canView,
        canDelete: canView,
      };
    }
    return { canView: true, canCreate: true, canEdit: true, canDelete: true };
  } catch {
    return { canView: true, canCreate: true, canEdit: true, canDelete: true };
  }
}

/**
 * Quyền màn Bảng giá (/levels, /level/:id): admin full; member theo từng cột.
 * @param {import('axios').AxiosInstance} axiosInstance
 */
export async function fetchPriceLevelPermissions(axiosInstance) {
  try {
    const flagsRes = await axiosInstance.get("/api/users/myFlags");
    const flags = flagsRes?.data?.data || {};
    if (flags?.isAdmin === true) {
      return { canView: true, canCreate: true, canEdit: true, canDelete: true };
    }
    if (flags?.isMember === true) {
      const permRes = await axiosInstance.get("/api/users/myDivisionPermissions");
      const rows = permRes?.data?.data || [];
      const target = normalizeDivisionFeatureName(PRICE_LEVEL_DIVISION_FEATURE);
      const row = rows.find((p) => normalizeDivisionFeatureName(p?.feature) === target);
      return {
        canView: Boolean(row?.view),
        canCreate: Boolean(row?.create),
        canEdit: Boolean(row?.edit),
        canDelete: Boolean(row?.delete),
      };
    }
    return { canView: true, canCreate: true, canEdit: true, canDelete: true };
  } catch {
    return { canView: true, canCreate: true, canEdit: true, canDelete: true };
  }
}

/**
 * Quyền chi tiết màn quản lý đơn: Đơn thường / Đơn VAT / Excel / Mua hộ + {@link ORDER_DIVISION_FEATURE} legacy.
 * @param {import('axios').AxiosInstance} axiosInstance
 */
export async function fetchOrdersDivisionPermissions(axiosInstance) {
  const fullAccess = () => ({
    loaded: true,
    menuView: true,
    normal: { view: true, create: true, edit: true, delete: true },
    vat: { view: true, create: true, edit: true, delete: true },
    excel: Object.fromEntries(ORDER_EXCEL_EXPORT_FEATURES.map((f) => [f, true])),
    quickUpdate: Object.fromEntries(ORDER_QUICK_UPDATE_FEATURES.map((f) => [f, true])),
    muaHo: true,
    canFilterMuaHo: true,
    muaHoOnlyViewer: false,
    muaHoNormal: { view: true, create: true, edit: true, delete: true },
    muaHoVat: { view: true, create: true, edit: true, delete: true },
  });

  try {
    const flagsRes = await axiosInstance.get("/api/users/myFlags");
    const flags = flagsRes?.data?.data || {};
    if (flags?.isAdmin === true) return fullAccess();
    if (flags?.isMember !== true) return fullAccess();

    const permRes = await axiosInstance.get("/api/users/myDivisionPermissions");
    const rows = permRes?.data?.data || [];
    /** Gộp khóa cũ «Cập nhật lại bảng giá» → «Tính toán lại chi phí» khi đọc JSON bộ phận. */
    const byNorm = new Map();
    for (const r of rows) {
      if (!r?.feature) continue;
      const canonical = migrateDivisionQuickUpdateFeatureKey(r.feature);
      const norm = normalizeDivisionFeatureName(canonical);
      const prev = byNorm.get(norm);
      if (!prev || Boolean(r.view) || Boolean(r.create) || Boolean(r.edit) || Boolean(r.delete)) {
        byNorm.set(norm, { ...r, feature: canonical });
      }
    }

    const pick = (featureName) => byNorm.get(normalizeDivisionFeatureName(featureName));

    const legacyOrder = pick(ORDER_DIVISION_FEATURE);
    const normalPick = pick(ORDERS_NORMAL_DIVISION_FEATURE);
    const vatPick = pick(ORDERS_VAT_DIVISION_FEATURE);

    /** Đồng bộ backend: chỉ fallback legacy khi JSON chưa có quyền con « ĐƠN HÀNG / … » nào (kể cả Excel, Mua hộ…). */
    const legacyNorm = normalizeDivisionFeatureName(ORDER_DIVISION_FEATURE);
    const hasOrderGranularChildren = rows.some((r) => {
      const k = normalizeDivisionFeatureName(r?.feature);
      return k.startsWith(`${legacyNorm} / `);
    });
    const fallbackNormal = (pickRow, legacyField) =>
      pickRow != null ? Boolean(pickRow?.[legacyField]) : !hasOrderGranularChildren && Boolean(legacyOrder?.[legacyField]);
    /** VAT không fallback legacy — đồng bộ backend applyOrderSearchLineViewScope. */
    const vatField = (pickRow, field) => (pickRow != null ? Boolean(pickRow?.[field]) : false);

    const normal = {
      view: fallbackNormal(normalPick, "view"),
      create: fallbackNormal(normalPick, "create"),
      edit: fallbackNormal(normalPick, "edit"),
      delete: fallbackNormal(normalPick, "delete"),
    };
    const vat = {
      view: vatField(vatPick, "view"),
      create: vatField(vatPick, "create"),
      edit: vatField(vatPick, "edit"),
      delete: vatField(vatPick, "delete"),
    };

    /** @type {Record<string, boolean>} */
    const excel = {};
    for (const f of ORDER_EXCEL_EXPORT_FEATURES) {
      excel[f] = Boolean(pick(f)?.view);
    }

    const quickUpdateAt = (f) => {
      const direct = pick(f)?.view;
      if (direct) return true;
      for (const [oldKey, newKey] of Object.entries(ORDER_QUICK_UPDATE_FEATURE_KEY_MIGRATION)) {
        if (newKey === f && pick(oldKey)?.view) return true;
      }
      return false;
    };

    /** @type {Record<string, boolean>} */
    const quickUpdate = {};
    const legacyQuickRow = pick(ORDER_QUICK_UPDATE_LEGACY_SINGLE_FEATURE);
    const legacyQuickView = Boolean(legacyQuickRow?.view);
    const granularQuickAny = ORDER_QUICK_UPDATE_FEATURES.some((f) => quickUpdateAt(f));
    for (const f of ORDER_QUICK_UPDATE_FEATURES) {
      if (f === ORDER_QUICK_UPDATE_RECALCULATE_FEE_FEATURE) {
        /** Quyền «Cập nhật nhanh» cũ (một dòng) bao gồm tính lại chi phí — kể cả khi đã bật quyền con khác. */
        quickUpdate[f] = quickUpdateAt(f) || legacyQuickView;
      } else {
        quickUpdate[f] = quickUpdateAt(f) || (!granularQuickAny && legacyQuickView);
      }
    }

    const legacyMuaHo = pick(ORDERS_MUA_HO_DIVISION_FEATURE);
    const muaHoNormalPick = pick(ORDERS_MUA_HO_NORMAL_DIVISION_FEATURE);
    const muaHoVatPick = pick(ORDERS_MUA_HO_VAT_DIVISION_FEATURE);
    const hasMuahoGranularChildren = muaHoNormalPick != null || muaHoVatPick != null;
    const muaHoNormal = buildMuaHoDivisionPermissionSlice(muaHoNormalPick, legacyMuaHo, hasMuahoGranularChildren);
    const muaHoVat = buildMuaHoDivisionPermissionSlice(muaHoVatPick, legacyMuaHo, hasMuahoGranularChildren);
    const canFilterMuaHo = hasMuahoGranularChildren
      ? muaHoNormal.view || muaHoVat.view
      : Boolean(legacyMuaHo?.view);
    const muaHo = canFilterMuaHo;
    /** Chỉ quyền xem mua hộ, không xem đơn vận chuyển (Đơn thường / Đơn VAT) → danh sách chỉ đơn có NCC. */
    const muaHoOnlyViewer = canFilterMuaHo && !normal.view && !vat.view;

    const menuView =
      Boolean(legacyOrder?.view) ||
      normal.view ||
      vat.view ||
      muaHo ||
      Object.values(excel).some(Boolean) ||
      Object.values(quickUpdate).some(Boolean) ||
      ORDER_RECONCILE_COLUMN_FEATURES.some((f) => Boolean(pick(f)?.view));

    return {
      loaded: true,
      menuView,
      normal,
      vat,
      excel,
      quickUpdate,
      muaHo,
      canFilterMuaHo,
      muaHoOnlyViewer,
      muaHoNormal,
      muaHoVat,
    };
  } catch {
    return fullAccess();
  }
}

/** Line VAT (khớp CommonConstant.MD_LINE_VAT). */
export const ORDER_VAT_LINE_ID = 12;

/** @param {object|null|undefined} pickRow */
function muaHoCrudFromPickRow(pickRow) {
  return {
    view: Boolean(pickRow?.view),
    create: Boolean(pickRow?.create),
    edit: Boolean(pickRow?.edit),
    delete: Boolean(pickRow?.delete),
  };
}

/**
 * Quyền Đơn hàng mua hộ (thường / VAT) từ JSON phòng ban.
 * @param {object|null|undefined} pickRow — quyền con; null nếu chưa cấu hình
 * @param {object|null|undefined} legacyRow — «ĐƠN HÀNG / Mua hộ» cũ
 * @param {boolean} hasMuahoGranularChildren — đã có ít nhất một quyền con mua hộ trong JSON
 */
function buildMuaHoDivisionPermissionSlice(pickRow, legacyRow, hasMuahoGranularChildren) {
  if (pickRow != null) {
    return muaHoCrudFromPickRow(pickRow);
  }
  if (!hasMuahoGranularChildren && legacyRow != null) {
    return muaHoCrudFromPickRow(legacyRow);
  }
  return { view: false, create: false, edit: false, delete: false };
}

/**
 * Hiển thị / sửa khối product_provider theo quyền mua hộ.
 * - Đơn mới: cần quyền Thêm (create); không có → ẩn.
 * - Đơn đã có: cần quyền Xem (view) để hiện; không có quyền Sửa (edit) → readonly.
 * @param {{ muaHoNormal?: { view?: boolean, create?: boolean, edit?: boolean }, muaHoVat?: { view?: boolean, create?: boolean, edit?: boolean } }} perm
 * @param {number|string|null|undefined} lineId
 * @param {number|string|null|undefined} orderId — null/undefined = thêm mới
 */
export function resolveOrderMuaHoSupplierSectionAccess(perm, lineId, orderId) {
  const slice =
    Number(lineId) === ORDER_VAT_LINE_ID ? perm?.muaHoVat : perm?.muaHoNormal;
  const view = Boolean(slice?.view);
  const create = Boolean(slice?.create);
  const edit = Boolean(slice?.edit);
  const isNew = orderId == null || orderId === "" || Number(orderId) <= 0;
  if (isNew) {
    return { show: create, editable: create };
  }
  return { show: view, editable: edit };
}

/** Có được dùng lọc «Mua hộ» trên danh sách đơn (cần quyền Xem mua hộ thường hoặc VAT). */
export function canFilterMuaHoOrders(perm) {
  if (!perm) return false;
  if (typeof perm.canFilterMuaHo === "boolean") return perm.canFilterMuaHo;
  return Boolean(perm.muaHoNormal?.view || perm.muaHoVat?.view || perm.muaHo);
}

/** Chỉ xem đơn mua hộ (có NCC), không xem đơn vận chuyển thuần. */
export function isMuaHoOnlyOrderViewer(perm) {
  if (!perm) return false;
  if (typeof perm.muaHoOnlyViewer === "boolean") return perm.muaHoOnlyViewer;
  return canFilterMuaHoOrders(perm) && !perm?.normal?.view && !perm?.vat?.view;
}

export const MUA_HO_ORDER_FILTER_SUPPORT_VALUE = "Mua hộ";

/**
 * Kiểm tra NCC trước khi lưu đơn mua hộ (tạo từ «+ Mua hộ»).
 * @returns {{ message: string, name: string } | null}
 */
export function validateMuaHoSupplierBeforeSave({ requireMuaHoSupplier, model, vatMode }) {
  if (!requireMuaHoSupplier) return null;
  if (vatMode) {
    const details = model?.details ?? [];
    const withProduct = details.filter((d) => String(d?.productName ?? "").trim());
    if (withProduct.length === 0) {
      return {
        message: "Đơn mua hộ bắt buộc chọn nhà cung cấp cho sản phẩm.",
        name: "providerName",
      };
    }
    for (const d of withProduct) {
      if (!String(d?.providerName ?? "").trim()) {
        return {
          message: "Đơn mua hộ bắt buộc chọn nhà cung cấp cho từng sản phẩm.",
          name: "providerName",
        };
      }
    }
    return null;
  }
  if (!String(model?.providerName ?? "").trim()) {
    return {
      message: "Đơn mua hộ bắt buộc chọn nhà cung cấp.",
      name: "providerName",
    };
  }
  return null;
}

/** Gộp quyền vận chuyển + mua hộ theo từng line (mở chi tiết đơn, lịch sử, …). */
export function mergeOrderPermissionSlices(transportSlice, muaHoSlice) {
  const a = transportSlice || {};
  const b = muaHoSlice || {};
  return {
    view: Boolean(a.view || b.view),
    create: Boolean(a.create || b.create),
    edit: Boolean(a.edit || b.edit),
    delete: Boolean(a.delete || b.delete),
  };
}

/**
 * Quyền thao tác đơn theo line: «Đơn thường/VAT» vận chuyển OR «Đơn hàng mua hộ» cùng loại line.
 * @param {{ normal?: object, vat?: object, muaHoNormal?: object, muaHoVat?: object }} perm
 * @param {number|string|null|undefined} lineId
 */
export function orderPermSliceForLine(perm, lineId) {
  const vatLine = Number(lineId) === ORDER_VAT_LINE_ID;
  return mergeOrderPermissionSlices(
    vatLine ? perm?.vat : perm?.normal,
    vatLine ? perm?.muaHoVat : perm?.muaHoNormal
  );
}

/** @deprecated Dùng {@link resolveOrderMuaHoSupplierSectionAccess} */
export function canViewOrderMuaHoSupplierSection(perm, lineId) {
  return resolveOrderMuaHoSupplierSectionAccess(perm, lineId, 1).show;
}

/**
 * Quyền màn Quản lý đơn hàng (/quan-li-don-hang): gộp Đơn thường + Đơn VAT (tương thích code cũ).
 * @param {import('axios').AxiosInstance} axiosInstance
 */
export async function fetchOrderPermissions(axiosInstance) {
  const p = await fetchOrdersDivisionPermissions(axiosInstance);
  return {
    canView: p.menuView,
    canCreate: p.normal.create || p.vat.create,
    canEdit: p.normal.edit || p.vat.edit,
    canDelete: p.normal.delete || p.vat.delete,
  };
}

/**
 * Quyền màn Danh sách users (/admin-users): admin full; member theo chức năng {@link ADMIN_USERS_LIST_DIVISION_FEATURE}
 * (view / create / edit).
 * @param {import('axios').AxiosInstance} axiosInstance
 */
export async function fetchAdminUsersListPermissions(axiosInstance) {
  try {
    const flagsRes = await axiosInstance.get("/api/users/myFlags");
    const flags = flagsRes?.data?.data || {};
    if (flags?.isAdmin === true) {
      return { canView: true, canCreate: true, canEdit: true };
    }
    if (flags?.isMember === true) {
      const permRes = await axiosInstance.get("/api/users/myDivisionPermissions");
      const rows = permRes?.data?.data || [];
      const target = normalizeDivisionFeatureName(ADMIN_USERS_LIST_DIVISION_FEATURE);
      const row = rows.find((p) => normalizeDivisionFeatureName(p?.feature) === target);
      return {
        canView: Boolean(row?.view),
        canCreate: Boolean(row?.create),
        canEdit: Boolean(row?.edit),
      };
    }
    return { canView: true, canCreate: true, canEdit: true };
  } catch {
    return { canView: true, canCreate: true, canEdit: true };
  }
}
